// Third Party Library
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Tabs, message } from "antd";

// Constants Library

// Components Library
import SearchFile from "./components/SearchFile";

// Handler Library
import { tableHDLR } from "../../../../handlers";

// Services Library
import { REDUX as REDUX_UTIL } from "../../../../services/util";

// Redux Actions
import * as REDUX_ACTION from "../../../../services/redux/actions";
import { TableItems } from "./components/TableFile/items";

const { reduxStoreWrapper } = REDUX_UTIL;

const FileView = (props) => {
    const { col } = props;

    const payrolls = useSelector(reduxStoreWrapper("payroll.byID")) || {};
    const payrollsCoid = useSelector(reduxStoreWrapper("payroll.byCoid")) || {};
    const user = useSelector(reduxStoreWrapper("user"));
    const company = useSelector(reduxStoreWrapper("company.byID"));
    const employee = useSelector(reduxStoreWrapper("employee.byID"));
    const employeeCoid = useSelector(reduxStoreWrapper("employee.byCoid"));
    const loyalty = useSelector(reduxStoreWrapper("loyalty.byID"));

    const [messageApi, contextHolder] = message.useMessage();
    const [tabKey, setTabKey] = useState("all");
    const [current, setCurrent] = useState(1);
    const [filteredData, setFilteredData] = useState([]);
    const [file, setFile] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [paginatedData, setPaginatedData] = useState([]);

    // Filtered Data
    const statusText = {
        all: "all",
        open: 1,
        closed: 0,
    };

    const handleTab = (key) => {
        setTabKey(key);
        setCurrent(1);
    };

    function countStatuses(data) {
        const statusCounts = {};

        data.forEach(s => {
          const status = s.status;
          
          if (statusCounts[status]) {
            statusCounts[status]++;
          } else {
            statusCounts[status] = 1;
          }
        });
        
        return statusCounts;
    }

    const handlePageChange = (page) => {
        const sorted = tableHDLR.dataTableSorting(page);
        setPaginatedData(sorted);
      };

    useEffect(() => {
        const groupedData = Object.values(payrolls).reduce((acc, payroll) => {
            const { csv } = payroll?.attachment?.rhb || {};
            const ltyid = payroll.loyaltyTier !== "-" && payroll.loyaltyTier?.split("#");
            const lty = loyalty[ltyid?.[0]];
            const companyName = company[payroll.coid]?.name;

            const payrollData = {
                ...payroll,
                company_name : companyName,
                key: payroll.prid,
                loyalty: lty && Object.values(lty).length ? lty : {},
            }
            if (csv === undefined || payroll.status === 1 || payroll.status === 2) {
                return acc;
            }
            if (!acc[csv]) {
                acc[csv] = {
                    payrolls: [],
                    totalPaymentAmount: 0,
                };
            }
            acc[csv].payrolls.push(payrollData);
            acc[csv].totalPaymentAmount += payroll.reqAmount;

            return acc;
        }, {});

        const groupedArray = Object.keys(groupedData).map(key => ({
            attachment_name: key,
            payrolls: groupedData[key].payrolls,
            totalPaymentAmount: groupedData[key].totalPaymentAmount,
            companyCountMap: groupedData[key].companyCountMap,
        })); 

        const payrollFile = groupedArray.map(data => {
            const mediaTypes = data.payrolls
                .map(payroll_data => payroll_data.company_name)
                .filter((company_name, index, array) => array.indexOf(company_name) === index);
        
            const counts = mediaTypes.map(mediaType => ({
                company_type: mediaType,
                count: data.payrolls.filter(payroll_data => payroll_data.company_name === mediaType).length
            }));

            const attachmentStatuses = data.payrolls
                .flatMap(payroll => Object.values(payroll.attachment || {}))
                .map(rhb => rhb.isClosed ?? 0);

            const isAnyAttachmentClosed = attachmentStatuses.some(status => status === 1);
            const result = isAnyAttachmentClosed ? 1 : 0;
        
            return {
                attachment_name: data.attachment_name,
                payrolls: data.payrolls,
                totalPaymentAmount: data.totalPaymentAmount,
                companyCountMap: counts,
                isClosed: result,
                status: result
            };
        });

        const updatedPayroll = payrollFile.map((t) => {
            const rhb = t.attachment_name;
            const rhbFile = rhb?.split("/");
            const rhbName = rhbFile && rhbFile.length > 5 ? rhbFile[5] : "";
            const generatedBy = t.payrolls[0]?.createdBy_name || "-";
            
            return {
              ...t,
              key: t.attachment_name,
              rhbName: rhbName,
              totalPayroll: t.payrolls.length,
              totalPaymentAmount: t.totalPaymentAmount,
              advanceSummary: countStatuses(t.payrolls),
              companyCountMap: t.companyCountMap,
              isClosed: t.isClosed,
              status: t.isClosed,
              generatedBy: generatedBy,
              createdAt: t.payrolls[0]?.createdAt,
              remarkCount: t.payrolls[0]?.attachment?.rhb?.remarkCount || 0,
            };
        });
          setFile(updatedPayroll);
    }, [payrolls]);

    useEffect(() => {
        if (file.length > 0)
          setFilteredData(tableHDLR.dataTableSorting(file));
    }, [file]);

    // Pagination
    const filteredDataCount = tableHDLR.dataCount(statusText, filteredData);

    useEffect(() => {
        if(filteredData.length){
            const startIndex = (current - 1) * pageSize;
            const endIndex = startIndex + pageSize;
            const newData = tableHDLR.datasourceFilter(filteredData, tabKey) ?? []
            const slicedData = newData.slice(startIndex, endIndex);

            setPaginatedData(slicedData);
        }
    }, [current, pageSize, filteredData, tabKey]);


    return (
        <>
        {contextHolder}
        <div
            style={{ width: "80vw", marginTop: "4vw" }}
        >
            <SearchFile
                tabKey={tabKey}
                pageSize={pageSize}
                setPageSize={setPageSize}
                handlePaginatedDataChange={handlePageChange}
                filteredDataCount={filteredDataCount}
                data={filteredData}
                current={current}
                setCurrent={setCurrent}
            />
            <div>
            <Tabs
                onTabClick={handleTab}
                items={TableItems(
                    filteredDataCount,
                    file,
                    filteredData,
                    paginatedData,
                    tabKey,
                    setFilteredData,
                )}
            />
            </div>
        </div>
        </>
    )
}

export default FileView